<template>
  <div
    class="dataLiveStatusChoice"
    role="radiogroup"
    :aria-label="ariaLabel"
  >
    <button
      v-for="option in options"
      :key="String(option.value)"
      type="button"
      class="dataLiveStatusChoice__btn"
      :class="[
        `dataLiveStatusChoice__btn--${option.value}`,
        { 'dataLiveStatusChoice__btn--active': isActive(option.value) },
      ]"
      :disabled="disabled"
      @click="select(option.value)"
    >
      <span class="dataLiveStatusChoice__dot" aria-hidden="true" />
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'DataLiveStatusChoice',
  props: {
    value: { type: [String, Number], default: '' },
    disabled: { type: Boolean, default: false },
    ariaLabel: { type: String, default: '发布状态' },
  },
  data() {
    return {
      options: [
        { label: '上线', value: '1' },
        { label: '下线', value: '0' },
      ],
    }
  },
  methods: {
    isActive(optionValue) {
      return String(this.value) === String(optionValue)
    },
    select(optionValue) {
      if (this.disabled || this.isActive(optionValue)) {
        return
      }
      this.$emit('input', optionValue)
      this.$emit('change', optionValue)
    },
  },
}
</script>

<style scoped>
.dataLiveStatusChoice {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  min-width: 200px;
}

.dataLiveStatusChoice__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0;
  min-height: 40px;
  padding: 10px 14px;
  border: 1px solid var(--link-line-strong, #e5dfd6);
  border-radius: 10px;
  background: var(--link-field-bg, #f3f0ea);
  color: var(--link-ink-secondary);
  font-family: var(--link-font-family);
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-medium);
  line-height: 1.2;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
}

.dataLiveStatusChoice__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.45;
}

.dataLiveStatusChoice__btn--1.dataLiveStatusChoice__btn--active {
  border-color: #86efac;
  background: #ecfdf3;
  color: #15803d;
  font-weight: var(--link-font-semibold);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
}

.dataLiveStatusChoice__btn--1.dataLiveStatusChoice__btn--active .dataLiveStatusChoice__dot {
  opacity: 1;
  background: #22c55e;
}

.dataLiveStatusChoice__btn--0.dataLiveStatusChoice__btn--active {
  border-color: #d6d3d1;
  background: #f5f5f4;
  color: #57534e;
  font-weight: var(--link-font-semibold);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
}

.dataLiveStatusChoice__btn--0.dataLiveStatusChoice__btn--active .dataLiveStatusChoice__dot {
  opacity: 1;
  background: #a8a29e;
}

.dataLiveStatusChoice__btn:hover:not(:disabled):not(.dataLiveStatusChoice__btn--active) {
  border-color: var(--link-ink-faint, #d6d3d1);
  color: var(--link-ink);
}

.dataLiveStatusChoice__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
</style>
